import styled from 'styled-components';
import { pickThemeFontStyles } from '@/theme';

export const StyledPhotoInfo = styled.div`
  display: flex;
  margin-top: 0.125rem;
  ${pickThemeFontStyles('12', '22', 'NORMAL')};
`;

export const StyledFileName = styled.div`
  margin-top: 0.5rem;
  text-decoration: underline;
`;

export const StyledImage = styled.img`
  border-radius: 0.75rem;
  max-width: 15rem;
  max-height: 8rem;
  object-fit: cover;
  width: 100%;
  margin-bottom: 0.5rem;
`;
